import { useEffect, useState } from 'react'
import { Container, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { pagesService, type Page } from '../services/pagesService'
import BlockRenderer from '../components/blocks/BlockRenderer'
import PageContainer from '../components/ui/PageContainer'
import { EmptyState, LoadingState } from '../components/ui/States'

/**
 * Renders a composed page by slug (the page builder output). Used for the
 * event home page (slug="home") and admin-created custom pages (/p/:slug).
 */
export default function PageView({ slug: slugProp }: { slug?: string }) {
  const params = useParams()
  const slug = slugProp ?? params.slug ?? 'home'
  const [page, setPage] = useState<Page | null>(null)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    setLoading(true)
    setNotFound(false)
    pagesService
      .getPage(slug)
      .then(setPage)
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false))
  }, [slug])

  if (loading) return <LoadingState />
  if (notFound || !page)
    return (
      <PageContainer>
        <EmptyState title="Page not found" />
      </PageContainer>
    )

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {!page.isHome && (
        <Typography variant="h4" fontWeight={800} sx={{ mb: 3 }}>
          {page.title}
        </Typography>
      )}
      <BlockRenderer blocks={page.blocks} />
    </Container>
  )
}
